import axios from 'axios';
import { TokenLogout } from 'API/Logout/logout';

const url = process.env.REACT_APP_BACKEND_URL;

export const MapDetails = async (page, rowsPerPage, FilterData, setIsloading, setMapData, setError, setTotalCount) => {
  const params = new URLSearchParams();
  params.append('user_type', FilterData.user_type);
  params.append('mapped_state', FilterData.map_type);
  params.append('state_id', FilterData.state);
  params.append('district_id', FilterData.district);
  params.append('page', page);
  params.append('limit', rowsPerPage);

  setIsloading(true);
  try {
    await axios
      .get(`${url}/map/mapping_details`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        },
        params
      })
      .then((res) => {
        if (res.status === 200) {
          setMapData(res.data.data);
          setTotalCount(res.data.total_count);
          setIsloading(false);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setError(error.response ? error.response.data.error : 'Something went wrong');
        setIsloading(false);
      });
  } catch (error) {
    TokenLogout(error);
    setError(error.response ? error.response.data.error : 'Something went wrong');
    setIsloading(false);
  }
};

export const ViewDetailsApi = async (type, data, setViewData, setIsloading, setError) => {
  setIsloading(true);

  try {
    await axios
      .post(
        `${url}/map/get_user_mapping_details`,
        {
          user_id: data,
          user_type: type
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setViewData(res.data);
          setIsloading(false);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setError(error.response ? error.response.data.error : 'Something went wrong');
        setIsloading(false);
      });
  } catch (error) {
    TokenLogout(error);
    setError(error.response ? error.response.data.error : 'Something went wrong');
    setIsloading(false);
  }
};

export const StateIdApi = async (setStateData, setIsloading) => {
  setIsloading(true);
  try {
    await axios
      .get(`${url}/map/get_stateids`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        }
      })
      .then((res) => {
        if (res.status === 200) {
          console.log("res.data",typeof(res.data));
          
          setStateData(res.data);
          setIsloading(false);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        // setError(error.response ? error.response.data.error : 'Something went wrong');
        setIsloading(false);
      });
  } catch (error) {
    TokenLogout(error);
    // setError(error.response ? error.response.data.error : 'Something went wrong');
    setIsloading(false);
  }
};

export const DistrictIdApi = async (setDistrictData, setIsloading, state) => {
  setIsloading(true);
  const params = new URLSearchParams();
  params.append('state_id', state ? state : '');
  try {
    await axios
      .get(`${url}/map/get_districtids`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        },
        params
      })
      .then((res) => {
        if (res.status === 200) {
          setDistrictData(res.data);
          setIsloading(false);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        // setError(error.response ? error.response.data.error : 'Something went wrong');
        setIsloading(false);
      });
  } catch (error) {
    TokenLogout(error);
    // setError(error.response ? error.response.data.error : 'Something went wrong');
    setIsloading(false);
  }
};

export const MappingUpdateApi = async (
  Id,
  user_type,
  selectedStates,
  selectedDistricts,
  setSuccess,
  setIsloading,
  setError,
  refunction,
  setDetails,
  setConfirmDialog
) => {
  setIsloading(true);
  const stateIds = selectedStates.map((state) => state.state_id);
  const districtIds = selectedDistricts.map((district) => district.district_id);
  setConfirmDialog(false)
  try {
    await axios
      .post(
        `${url}/map/update_location`,
        {
          user_id: Id,
          user_type: user_type,
          stateids: stateIds,
          districtids: districtIds
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setSuccess(res.data.message);
          setTimeout(() => {
            setIsloading(false);
            setDetails(false);
            refunction();
          }, 2000);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setError(error.response ? error.response.data.error : 'Something went wrong');
        setIsloading(false);
      });
  } catch (error) {
    TokenLogout(error);
    setError(error.response ? error.response.data.error : 'Something went wrong');
    setIsloading(false);
  }
};

export const DeleteLocationApi = async (user_id, user_type, value, setIsloading, setSuccess, setError, refunction, data,setConfirmDialog) => {
  setIsloading(true);
  setConfirmDialog(false)
  try {
    await axios
      .post(
        `${url}/map/delete_location`,
        {
          user_id: user_id,
          user_type: user_type,
          ...(data === 'state' && { state_id: value }),
          ...(data === 'district' && { district_id: value })
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setSuccess(res.data.message);
          setTimeout(() => {
            setIsloading(false);
            refunction();
          }, 2000);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setError(error.response ? error.response.data.error : 'Something went wrong');
        setIsloading(false);
      });
  } catch (error) {
    TokenLogout(error);
    setError(error.response ? error.response.data.error : 'Something went wrong');
    setIsloading(false);
  }
};
